<script>
export default {
  props: {
    itemMinWidth: {
      type: Number,
      default: 200,
    },
  },
  computed: {
    formGroupStyle() {
      return `--item-min-width: ${this.itemMinWidth}px`
    },
  },
}
</script>

<template>
  <div :class="$style.formGroup" :style="formGroupStyle">
    <slot />
  </div>
</template>

<style lang="scss" module>
@import '@design';

$line-margin: 10px;

.formGroup {
  @media (max-width: $lg-breakpoint) {
    margin-right: -30px;
    margin-bottom: 0;
  }

  display: flex;
  flex-wrap: wrap;
  margin-bottom: 18px;
  gap: 10px 0;

  > * {
    flex: 1 1;
    min-width: var(--item-min-width);
    margin-right: 30px;
  }
}
</style>
